export function popup() {
  const popupOpeners = document.querySelectorAll('.opener-popup');
  const popupClosers = document.querySelectorAll('.closers-popup');
  const popupGallery = document.querySelector('.popup.images');
  const popupForm = document.querySelector('.contact-us');
  const bodyEl = document.body;
  const OVERFLOW_CLASS = 'overflow';
  const SHOW_CLASS = 'open-popup';

  if (!(popupOpeners.length || popupClosers.length || popupGallery || popupForm)) {
    return;
  }

  function openPopup(type, button) {
    bodyEl.classList.add(OVERFLOW_CLASS);

    if (type === 'gallery') {
      const popupImg = popupGallery.querySelector('.popup__picture');
      const imgLink = button.dataset.img;

      popupImg.src = imgLink;
      popupGallery.classList.add(SHOW_CLASS);
    } else if (type === 'contact-us') {
      popupForm.classList.add(SHOW_CLASS);
    }
  }

  function closePopup(popup) {
    const popupContainer = popup.closest('.popup');

    if (popupContainer) {
      bodyEl.classList.remove(OVERFLOW_CLASS);
      popupContainer.classList.remove(SHOW_CLASS);
    }
  }

  popupOpeners.forEach(buttonElement => {
    buttonElement.addEventListener('click', function () {
      const dataType = this.dataset.popup;

      openPopup(dataType, buttonElement);
    });
  });

  popupClosers.forEach(buttonElement => {
    buttonElement.addEventListener('click', function () {
      closePopup(this);
    });
  });
}


// WEBPACK FOOTER //
// app/scripts/components/popup.js